import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Table } from '../../../_models/Table';
import { Restaurant } from '../../../_models/Restaurant';
import { ApiService } from '../../../_services';
import { RestaurantSlotTableWithInfo } from '../../../_models/RestaurantSlot';
import { SpinnerService } from '../../../_components/spinner/spinner.service';
import { DateTime } from 'luxon';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-table-card',
  templateUrl: './table-card.component.html',
  styleUrl: './table-card.component.scss',
  standalone: true,
  imports: [TranslateModule],
})
export class TableCardComponent implements OnInit, OnChanges {
  @Input() date: Date | undefined;
  @Input() restaurant: Restaurant | undefined;
  tables: RestaurantSlotTableWithInfo[] = [];
  @Input() selectedTable: RestaurantSlotTableWithInfo | undefined;
  @Output() selectedTableChange =
    new EventEmitter<RestaurantSlotTableWithInfo>();
  @Output() sizeChange = new EventEmitter<Table>();
  @Input() reservedTableId: number | undefined;

  constructor(
    private apiService: ApiService,
    private spinner: SpinnerService
  ) {}
  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['date']?.currentValue) {
      this.getTables();
    }
  }
  getTables() {
    this.spinner.show();
    let formattedDate = DateTime.fromJSDate(this.date!).toSQLDate();
    this.apiService
      .TableSlots(
        this.restaurant!.id_restaurant,
        formattedDate!,
        this.reservedTableId
      )
      .subscribe({
        next: (tables) => {
          this.tables = tables;
          if (this.reservedTableId) {
            let reservationTable = this.tables.find(
              (t) => t.id_restaurant_slot_table === this.reservedTableId
            );
            if (reservationTable) {
              this.tableSelected(reservationTable);
            }
          }
          this.spinner.hide();
        },
        error: (err) => {
          console.log(err);
          this.spinner.hide();
        },
      });
  }
  tableSelected(selectedTable: RestaurantSlotTableWithInfo) {
    this.selectedTable = selectedTable;
    this.selectedTableChange.emit(selectedTable);
  }

  isSelected(table: RestaurantSlotTableWithInfo): boolean {
    return (
      this.selectedTable?.id_restaurant_slot_table ===
      table.id_restaurant_slot_table
    );
  }
}
